module.exports = __webpack_public_path__ + "img/yaryna-mandyuk.3c8ec135.jpg";